import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["selector", "button", "panel"]
  static values = { linkedPanelId: String }

  declare readonly selectorTarget: HTMLSelectElement
  declare readonly buttonTargets: HTMLElement[]
  declare readonly panelTargets: HTMLElement[]
  declare readonly hasLinkedPanelIdValue: boolean
  declare readonly linkedPanelIdValue: string

  connect() {
    this.render(this.selectorTarget.value)
  }

  select(event: Event & { params: { mode?: string } }) {
    const mode = event.params.mode || (event.currentTarget as HTMLSelectElement).value
    this.selectorTarget.value = mode
    this.render(mode)
  }

  render(mode: string) {
    this.buttonTargets.forEach((button) => {
      const active = button.dataset.propertyTabModeParam === mode
      button.classList.toggle("bg-primary", active)
      button.classList.toggle("text-white", active)
      button.classList.toggle("text-black", !active)
    })
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.propertyTabMode !== mode)
    })

    if (this.hasLinkedPanelIdValue) {
      const linkedPanel = document.getElementById(this.linkedPanelIdValue)
      linkedPanel?.classList.toggle("hidden", linkedPanel.dataset.propertyTabMode !== mode)
    }
  }
}
